<template>
  <div class="page page-experts content">
    <h1 class="page__title">{{ t('experts.menuTitle') }}</h1>
    <ExpertSettings />
  </div>
</template>

<script setup>
  import ExpertSettings from '@/components/settings/ExpertSettings.vue'
  import { useStrings } from '@/composables/useStrings.ts'

  const { t } = useStrings()
</script>

<style lang="scss">
  .page-experts {
    max-width: $content-page-width;
  }
</style>
